/*!
 * Copyright © 2026. Verizon Connect Ireland Limited. All rights reserved.
 */

/**
 * Data source that produced the vehicle diagnostics reading.
 *
 * - `Ecm`: the reading comes from the vehicle's engine control module (full diagnostics available).
 * - `Gps`: the reading is derived from GPS only, so ECM-only fields (DTC, battery, fuel) are not available.
 *
 * The backend may return the raw value in different casing (e.g. `"Ecm"`, `"Gps"`), so comparisons
 * against this enum should be done case-insensitively.
 */
export enum EDiagnosticsSource {
  Gps = 'GPS',
  Ecm = 'ECM'
}
